import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {colorLike} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {z} from "zod/v4-mini"

export const DisplayMode = z.union([z.literal("normal"), z.literal("mask"), z.literal("low-pass")])

export const CorrectionMode = z.union([z.literal("offset"), z.literal("modulation")])

export const BlurSettings = z.object({
    enabled: z.boolean(),
    smoothingDistance: z.number().check(z.gte(0)),
})

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            sourceMean: z.optional(z.union([colorLike, z.number()])),
            maskImage: z.optional(anyImageOpResult),
            blurSettingsH: BlurSettings,
            blurSettingsV: BlurSettings,
            wrapAround: z.boolean(),
            intensity: z._default(z.number().check(z.gte(0), z.lte(1)), 1),
            angleOffset: z._default(z.number().check(z.gte(-180), z.lte(180)), 0),
            displayMode: z._default(DisplayMode, "normal"),
            correctionMode: z._default(CorrectionMode, "modulation"),
        }),
    },
}
